import { AdminEventApiPath, CalendarEvent, CoorgEventApiPath, useCalendarEventCoorgSchema, useCalendarEventSchema } from "./useEventsAdminList";
import { useCrudItem } from "../../../toolympus/api/useSimpleCrud";

export const useEditAdminEvent = (id: number) => {
  const data = useCrudItem<CalendarEvent>(`${AdminEventApiPath}/${id}`, {
    defaultValue: {
      _id: -1,
      title: "",
    }
  });

  const schema = useCalendarEventSchema();


  return {
    ...data,
    schema,
  };
}


export const useEditCoorgEvent = (id: number) => {
  const data = useCrudItem<CalendarEvent>(`${CoorgEventApiPath}/${id}`, {
    defaultValue: {
      _id: -1,
      title: "",
    }
  });

  const schema = useCalendarEventCoorgSchema();


  return {
    ...data,
    schema,
  };
}

